import * as React from 'react';
import { Container, Styler } from '@honeycomb/ui-core';
export function PlaceholderFooter() {
    return (React.createElement(Styler, { component: "footer", bg: "grey.dark", c: "common.white" },
        React.createElement(Container, { h: 400, display: "flex", alignItems: "center", justifyContent: "center" }, "YOUR FOOTER CONTENT")));
}
